/* Trang sản phẩm LEGENDBRIX — sinh bởi scripts/port_demo_product.py.
   Sửa file này sẽ bị build ghi đè; sửa trong script. */
(function () {
  var root = document.querySelector('.lb-demo .pdp');
  if (!root) return;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function each(sel, fn, scope) {
    Array.prototype.forEach.call((scope || root).querySelectorAll(sel), fn);
  }

  /* Gallery: đổi ảnh chính. Phải xoá srcset — image_tag sinh srcset, để lại thì
     trình duyệt vẫn chọn ảnh cũ theo srcset và src mới bị bỏ qua.

     Tách thành hàm vì có HAI đường gọi: bấm thumbnail, và đổi variant. */
  function datAnhChinh(url) {
    if (!url) return;
    /* Bám cả id lẫn class: `image_tag` chuyển tham số lạ thành attribute nhưng
       `class` là tham số CÓ tài liệu, `id` thì không — nếu Shopify bỏ id thì
       gallery vẫn đổi được ảnh. */
    var main = root.querySelector('#lbPmain') || root.querySelector('.pmain__img');
    if (!main) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = url;
  }

  function hienAnh(t) {
    if (!t) return;
    datAnhChinh(t.getAttribute('data-lb-full'));
    each('.thumb--on', function (x) { x.classList.remove('thumb--on'); });
    t.classList.add('thumb--on');
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lb-full]');
    if (t) hienAnh(t);
  });

  /* Số lượng. Không cho xuống dưới 1: Shopify coi quantity 0 là xoá dòng. */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lb-qty]');
    if (!b) return;
    var i = b.parentNode.querySelector('[data-lb-qtyinput]');
    if (!i) return;
    var n = parseInt(i.value, 10);
    if (isNaN(n)) n = 1;
    n += parseInt(b.getAttribute('data-lb-qty'), 10);
    i.value = n < 1 ? 1 : n;
  });

  /* Đổi variant -> đổi số hiển thị. Giỏ hàng KHÔNG phụ thuộc đoạn này: radio
     mang name="id" nên form POST gửi đúng variant dù JS chết. */
  root.addEventListener('change', function (e) {
    var r = e.target.closest('.vopt input[type=radio]');
    if (!r) return;
    each('.vopt', function (l) {
      l.classList.toggle('vopt--on', l.contains(r));
    });

    /* Ảnh lớn đi theo variant. Ưu tiên BẬT ĐÚNG THUMBNAIL của ảnh đó thay vì
       gán thẳng src: làm vậy thì ảnh lớn và dải thumbnail không nói hai chuyện
       khác nhau. `data-v-img` chỉ là đường lùi cho trường hợp ảnh của variant
       không nằm trong danh sách media của sản phẩm. */
    var mediaId = r.getAttribute('data-v-media');
    var th = mediaId ? root.querySelector('.thumb[data-lb-media="' + mediaId + '"]') : null;
    if (th) {
      hienAnh(th);
      /* Kéo dải thumbnail cho ô vừa bật nhìn thấy được. KHÔNG dùng
         scrollIntoView: nó cuộn cả trang theo trục dọc, khách đang đọc khối mua
         hàng sẽ bị giật đi. Tính bằng getBoundingClientRect chứ không offsetLeft
         — dải không có `position` nên offsetParent là một tổ tiên khác. */
      var rail = th.parentNode;
      if (rail && rail.scrollWidth > rail.clientWidth + 2) {
        var rt = th.getBoundingClientRect(), rr = rail.getBoundingClientRect();
        rail.scrollLeft += rt.left - rr.left - (rail.clientWidth - rt.width) / 2;
      }
    } else {
      datAnhChinh(r.getAttribute('data-v-img'));
    }
    var now = root.querySelector('.pprice [data-lb-now]');
    if (now) now.textContent = r.getAttribute('data-v-now') || '';
    /* Thanh mua dính đáy in lại cùng giá — để lệch thì khách đổi variant rồi
       cuộn xuống sẽ thấy hai con số khác nhau trên cùng một trang. */
    var satcP = root.querySelector('[data-lb-satc-price]');
    if (satcP) satcP.textContent = r.getAttribute('data-v-now') || '';
    var was = root.querySelector('.pprice [data-lb-was]');
    var off = root.querySelector('.pprice [data-lb-off]');
    var wasV = r.getAttribute('data-v-was');
    var offV = parseInt(r.getAttribute('data-v-off'), 10);
    if (was) { was.textContent = wasV || ''; was.hidden = !wasV; }
    if (off) {
      off.textContent = offV > 0 ? 'SAVE ' + offV + '% + FREE GIFTS' : '';
      off.hidden = !(offV > 0);
    }
  });

  /* Bundle 3 xe: combo CỐ ĐỊNH, không có tick lẻ nữa nên không phải tính lại
     tổng theo ô nào. Danh sách variant do Liquid in ra `data-lb-ids` (đã tra
     theo tên variant chứa 'Gift'), JS chỉ việc POST đúng ba dòng đó.

     Dùng `document` chứ không phải `root`: khối `.bdl` nằm NGOÀI `.pdp` để nó
     chiếm full chiều ngang, nên `root.querySelector` không thấy nó.

     KHÔNG tự áp giảm giá ở đây. 15% là Automatic Discount trong Shopify Admin;
     theme không có quyền hạ giá giỏ. Thêm hàng xong đưa sang /cart để khách
     thấy ngay con số đã giảm do Shopify tính. */
  /* ── Mở cart drawer sau khi thêm hàng ──────────────────────────────────────
     Trước đây mọi đường thêm giỏ đều `window.location.href = '/cart'`. Tải lại
     cả trang là mất chỗ khách đang đứng, và cắt luôn cơ hội bán thêm — drawer là
     nơi đặt bundle và cross-sell.

     Cơ chế lấy từ chính layout của theme (đoạn cart-discount-block trong
     theme.liquid): POST kèm `sections: ['cart-drawer','cart-icon-bubble']` để
     Shopify trả về HTML đã render của hai phần đó, rồi gọi
     `drawer.renderContents(data)`. Class `is-empty` phải bỏ tay, drawer không tự
     bỏ khi giỏ vừa từ trống thành có hàng.

     Trả về true nếu mở được. Gọi nơi nào KHÔNG mở được thì rơi về /cart — thà
     tải lại trang còn hơn khách bấm mà không thấy gì xảy ra. */
  var SECTIONS_GIO = ['cart-drawer', 'cart-icon-bubble'];

  function moDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    drawer.renderContents(data);
    var el = document.querySelector('cart-drawer.drawer');
    if (el) el.classList.remove('is-empty');
    return true;
  }

  var bdl = document.querySelector('[data-lb-bundle-add]');
  if (bdl) {
    bdl.addEventListener('click', function () {
      var ids = (bdl.getAttribute('data-lb-ids') || '')
                  .split(',').filter(function (s) { return s.trim() !== ''; });
      if (!ids.length) return;
      var nhan = bdl.textContent;
      bdl.disabled = true;
      bdl.textContent = 'ADDING…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: parseInt(id, 10), quantity: 1 };
          }),
          sections: SECTIONS_GIO,
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (data) {
        bdl.disabled = false;
        bdl.textContent = nhan;
        if (!moDrawer(data)) window.location.href = '/cart';
      }).catch(function () {
        /* Hỏng thì trả nút về nguyên trạng, không để khách kẹt ở "ADDING…". */
        bdl.disabled = false;
        bdl.textContent = nhan;
      });
    });
  }
  /* Add-on: mỗi nút thêm đúng một món, không tự thêm gì. */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lb-addon]');
    if (!b) return;
    add([{ id: b.getAttribute('data-lb-addon'), quantity: 1 }], b, '+ Add');
  });

  /* Một chỗ duy nhất gọi giỏ hàng. Lỗi thì NÓI RA trên nút, không im lặng:
     nút bấm không phản hồi là dấu hiệu store hỏng với đúng tệp khách này. */
  function add(items, btn, label) {
    var root_url = (window.Shopify && window.Shopify.routes
                    && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    var old = btn.innerHTML;
    btn.textContent = 'Adding…';
    fetch(root_url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: SECTIONS_GIO,
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (data) {
      btn.disabled = false;
      btn.innerHTML = old;
      if (!moDrawer(data)) window.location.href = root_url + 'cart';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Could not add — try again';
      setTimeout(function () { btn.innerHTML = old; }, 2600);
    });
  }

  // ── Cột ảnh dính: chọn mốc ghim theo chiều cao thật ────────────────────────
  // CSS đặt sẵn `top:24px`, đúng khi cột ảnh THẤP hơn màn hình. Nhưng số
  // thumbnail thay đổi theo từng xe: General Lee 8 ảnh -> cột cao 1028px, cao
  // hơn màn hình 960px, ghim mép trên thì hàng thumbnail cuối luôn nằm dưới
  // mép và khách không bao giờ thấy.
  //
  // Cách xử: khi cột cao hơn màn hình, đặt `top` ÂM đúng bằng phần dôi ra. Cột
  // cuộn lên tự nhiên cho tới khi ĐÁY nó chạm đáy màn hình rồi mới ghim — nhìn
  // được trọn dải thumbnail, không phải bỏ ảnh nào, không phải thu nhỏ ảnh.
  //
  // CSS thuần không làm được: `calc()` không đọc được chiều cao của chính phần
  // tử, mà chiều cao lại phụ thuộc số ảnh của từng sản phẩm.
  var LE = 24;                       // khoảng hở với mép màn hình
  function neoCotAnh() {
    var m = document.querySelector('.lb-demo .pdp__media');
    if (!m) return;
    if (!window.matchMedia('(min-width: 921px)').matches) { m.style.top = ''; return; }
    var moc = window.innerHeight - LE - m.offsetHeight;
    m.style.top = (moc < LE ? moc : LE) + 'px';
  }
  neoCotAnh();
  window.addEventListener('resize', neoCotAnh);
  // Ảnh tải xong thì chiều cao cột mới chốt — tính lại, nếu không mốc sẽ sai.
  window.addEventListener('load', neoCotAnh);

  /* Thanh mua dính đáy (CSS chỉ bật nó từ 921px trở lên).
     Chỉ hiện khi nút CHÍNH đã trôi lên TRÊN mép màn hình, không phải cứ
     `!isIntersecting` là hiện: lúc mới vào trang, màn hình thấp mà nút còn
     dưới nếp gấp thì isIntersecting cũng false, thanh dính hiện ngay trong khi
     nút thật chỉ cách một quãng cuộn — khách thấy hai nút mua cùng lúc.

     Phân biệt trên/dưới bằng `top` so với `rootBounds.top`, KHÔNG dùng
     `bottom < 0`: callback chỉ chạy đúng lúc vượt ngưỡng, ở đó bottom xấp xỉ 0
     nên `< 0` gần như luôn sai và thanh không bao giờ bật (đã đo: nút ở
     bottom -847 mà cờ vẫn false). */
  /* Cụm đánh giá trong thanh dính là bản clone của `.prate`: điểm số nằm cứng
     trong từng template nên nhân bản DOM rẻ hơn là khai lại ở bốn chỗ, và sau
     này sửa `.prate` thì thanh dính tự đổi theo. */
  var oRate = root.querySelector('.prate');
  var oSlot = root.querySelector('[data-lb-satc-rate]');
  if (oRate && oSlot && !oSlot.childNodes.length) {
    oSlot.appendChild(oRate.cloneNode(true));
  }

  var satc = root.querySelector('[data-lb-satc]');
  var nutChinh = root.querySelector('.qtyrow button[name=add]');
  if (satc && nutChinh && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (dong) {
      dong.forEach(function (d) {
        var mepTren = d.rootBounds ? d.rootBounds.top : 0;
        satc.classList.toggle('satc--on',
          !d.isIntersecting && d.boundingClientRect.top < mepTren);
      });
    }).observe(nutChinh);
  }
})();
